import { writable } from "svelte/store";
let FlashMessageStore;
export default FlashMessageStore = writable([]);
